import api from "@/api/apiConfig"
import {
  Post,
  Get,
  Put
} from './base/baseAjax'
let getDimiss = (param) => {
  return Post({
    url: api.dimission.getDimiss,
    bodyParam: param
  })
}
let resume = (param) => {
  return Put({
    url: api.dimission.resume,
    bodyParam: param
  })
}
let exportAll = () => {
  return Get({
    url: api.dimission.exportAll,
    config:{
      timeout:600000
    }
  })
}

export default {
  getDimiss,
  exportAll,
  resume
}



// WEBPACK FOOTER //
// ./src/services/dimission.js